import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const PROJET_API = "https://notregrandbleu.herokuapp.com/projet/";
const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class ProjetService {
  constructor(private http: HttpClient) { }
  public AfficherProjet(): Observable<any> 
  {
    return this.http.get(PROJET_API, httpOptions);
  }
  addProjet(projet): Observable<any> 
  {
    return this.http.post(PROJET_API + "ajoutProjet", projet, httpOptions);
  }
  deleteProjet(id): Observable<any> 
  {
    return this.http.get(PROJET_API + "supprimer/" + id, httpOptions);
  }
  modify(projet): Observable<any> 
  {
    return this.http.put(PROJET_API + "modifier", projet, httpOptions);
  }
}
